/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

export const trendSegmentDailyPreset = {
  rows: {
    header: [9, 10],
  },
  columns: {
    width: [25, 10, ...Array(44).fill(12)],
    end: 'AU',
  },
  table: {
    start: 9,
    end: 44,
    dataStart: 11,
  },
  totalRow: false,
  bordered: true,
};
//
export const trendSegmentCumulativePreset = {
  rows: {
    header: [9, 10],
  },
  columns: {
    width: [25, 10, ...Array(20).fill(12)],
    end: 'W',
  },
  table: {
    start: 9,
    end: 44,
    dataStart: 11,
  },
  totalRow: false,
  bordered: true,
};
//
export const trendSegmentPercentagePreset = {
  rows: {
    header: [8, 9],
  },
  columns: {
    width: [25, 10, ...Array(24).fill(12)],
    end: 'Z',
  },
  table: {
    start: 8,
    end: 44,
    dataStart: 10,
  },
  totalRow: false,
  bordered: true,
};
//
export const trendSegmentWeeklyPreset = {
  rows: {
    header: [9, 10],
  },
  columns: {
    width: [25, 10, ...Array(44).fill(12)],
    end: 'AU',
  },
  table: {
    start: 9,
    end: 44,
    dataStart: 11,
  },
  totalRow: false,
  bordered: true,
};
//
export const cmatSegmentDailyPreset = {
  rows: {
    header: [9, 10],
  },
  columns: {
    width: [30, 10, ...Array(60).fill(12)],
    end: 'Y',
  },
  table: {
    start: 9,
    end: 42,
    dataStart: 11,
  },
  totalRow: false,
  bordered: true,
};
